import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedService } from "@shared/shared.service";
import { NotifyMessageComponent } from "@shared/notify-message/notify-message.component";
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { SideMenuComponent } from "@shared/side-menu/side-menu.component";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { PermissionGuard } from "@myproject/perimission.guard";
import { AuthGuard } from "@myproject/auth.guard";
import { NgSelectModule } from "@ng-select/ng-select";
import { CalendarComponent } from "./calendar/calendar.component";
import { InlineEditComponent } from "./inline-edit/inline-edit.component";
import { MyRenderer } from "@shared/inline-edit/inline-edit.service";
import { InlineEditSelectComponent } from "./inline-edit-select/inline-edit-select.component";
import { DateTimeCalendarComponent } from "./date-time-calendar/date-time-calendar.component";
import {
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { SearchSelectDeviceComponent } from "./search-select-device/search-select-device.component";
import { ConfirmDeleteModalComponent } from "./confirm-delete-modal/confirm-delete-modal.component";
import { FileSizePipe } from "./custom-pipes/file-size.pipe";
import { SecondsToHmsPipe } from "@myproject/shared/seconds-to-hms.pipe";
import { EllipsesPipe } from "@myproject/shared/ellipses/ellipses.pipe";
import { CalendarGraphComponent } from "./calendar-graph/calendar-graph.component";
import { OtaFileUploadModalComponent } from "./ota-file-upload-modal/ota-file-upload-modal.component";
import { DeviceActivityComponent } from "./campaign-device-activity/device-activity.component";
import { HeaderComponent } from "@myproject/components/header/header.component";
import { FooterComponent } from "@myproject/layouts/footer/footer.component";
import { StatsCardComponent } from "./stats-card/stats-card.component";
import { TabListComponent } from "./tab-list/tab-list.component";
import { ReplayCustomCalendarComponent } from "./replay-custom-calendar/replay-custom-calendar.component";
import { SearchSelectVehicleComponent } from "./search-select-vehicle/search-select-vehicle.component";
import { ConnectionsTabHeaderComponent } from "./connections-tab-header/connections-tab-header.component";
import { ButtonDropdownComponent } from "./button-dropdown/button-dropdown.component";

@NgModule({
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    RouterModule,
    NgxDatatableModule,
    NgSelectModule,
    FormsModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbTooltipModule,
    ButtonDropdownComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NotifyMessageComponent,
    TranslatePipe,
    TranslateDirective,
    SideMenuComponent,
    CalendarComponent,
    InlineEditComponent,
    InlineEditSelectComponent,
    DateTimeCalendarComponent,
    SearchSelectDeviceComponent,
    ConfirmDeleteModalComponent,
    FileSizePipe,
    SecondsToHmsPipe,
    EllipsesPipe,
    CalendarGraphComponent,
    OtaFileUploadModalComponent,
    DeviceActivityComponent,
    RouterModule,
    FormsModule,
    CommonModule,
    NgxDatatableModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbTooltipModule,
    StatsCardComponent,
    TabListComponent,
    ReplayCustomCalendarComponent,
    SearchSelectVehicleComponent,
    ConnectionsTabHeaderComponent,
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    NotifyMessageComponent,
    SideMenuComponent,
    CalendarComponent,
    InlineEditComponent,
    InlineEditSelectComponent,
    DateTimeCalendarComponent,
    SearchSelectDeviceComponent,
    ConfirmDeleteModalComponent,
    FileSizePipe,
    SecondsToHmsPipe,
    EllipsesPipe,
    CalendarGraphComponent,
    OtaFileUploadModalComponent,
    DeviceActivityComponent,
    StatsCardComponent,
    TabListComponent,
    ReplayCustomCalendarComponent,
    SearchSelectVehicleComponent,
    ConnectionsTabHeaderComponent,
  ],
  providers: [
    SharedService,
    PermissionGuard,
    AuthGuard,
    MyRenderer,
  ],
})
export class SharedModule {}
